(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["plural-cart-button"] && !Shopify.designMode) return;
  try {
    // Collection AJAX replaces cards; a single delegated listener also handles
  // future cards without registering duplicate handlers on section reloads.
  if (!window.jpSavedCartClickBound) {
    window.jpSavedCartClickBound = true;
    document.addEventListener('click', function (event) {
      const button = event.target instanceof Element && event.target.closest('.save-product-button');
      if (!button) return;
      event.preventDefault();

      const unavailable = function () {
        if (button.dataset.savedCartMessage) return;
        button.dataset.savedCartMessage = button.textContent;
        button.textContent = 'Please try again shortly';
        window.setTimeout(function () {
          button.textContent = button.dataset.savedCartMessage;
          delete button.dataset.savedCartMessage;
        }, 2500);
      };
      const cartSaver = window.cartSaver;
      const variantId = button.dataset.variantId;
      if (!variantId || !cartSaver || typeof cartSaver.openSelector !== 'function') {
        unavailable();
        return;
      }

      try {
        cartSaver.productCallback = function () {
          return [{ variant_id: variantId, quantity: 1, properties: null }];
        };
        cartSaver.openSelector();
      } catch (error) {
        unavailable();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
